import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hw_block",
  "use": "hw_block-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"hw_block\"><g fill=\"#3A7EEA\" fill-rule=\"evenodd\"><path d=\"M0 0l1.262 12.14 5.8 3.72 5.803-3.72L14.127 0H0zm2.365 11.463L1.294 1.167h11.54l-1.072 10.296-4.7 3.011-4.697-3.011z\" /><path d=\"M2.482 3.13l7.897 8.115-3.314 1.93-3.817-2.228zM11.728 2.261l-.778 7.932L3.225 2.26z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id